<work-ui-modal #absenceCreateUpdateModal
               [showInlineBorders]="true"
               [titleText]="(absenceToUpdate() ? 'ABSENZ_BEARBEITEN' : 'ABSENZ_ERSTELLEN') | translate"
               modalId="absenceCreateUpdateModal">
  <ng-container modal-body>
    @if (absenceCreateUpdateModal.isOpen) {

      <!--CREATE-->
      @if (!absenceToUpdate()) {
        <form [formGroup]="formGroupCreate" autocomplete="off">
          <work-ui-select (valueChanged)="formGroupCreate.patchValue({timerecordtypeId: $event})"
                          [options]="(dropdownOptionsTimeRecordType$ | async) ?? []"
                          formControlName="timerecordtypeId"
                          label="TYP" />
          <work-ui-input-datepicker variant="dateRange"
                                    rangeStartDateFormControlName="start"
                                    rangeEndDateFormControlName="end"
                                    label="VON_BIS"
                                    rangeStartDatePlaceholder="VON"
                                    rangeEndDatePlaceholder="BIS" />
          <work-ui-select (valueChanged)="formGroupCreate.patchValue({dayPart: $event})"
                          [options]="dayPartOptions"
                          formControlName="dayPart"
                          label="TAGES_ANTEIL" />
          @if (formGroupCreate.value.timerecordtypeId && [6, 7].indexOf(formGroupCreate.value.timerecordtypeId) > -1) {
            <work-ui-input-field formControlName="percentage"
                                 label="ARBEITSUNFAEHIGKEIT"
                                 type="number" />
          }
          <work-ui-input-field formControlName="comment"
                               label="KOMMENTAR"
                               type="text"
                               variant="textarea"
                               [rows]="1"
                               [setAutoHeight]="true" />
        </form>
      }

      <!--UPDATE-->
      @if (absenceToUpdate()) {
        <form [formGroup]="formGroupUpdate" autocomplete="off">
          <work-ui-select (valueChanged)="formGroupUpdate.patchValue({timerecordtypeId: $event})"
                          [options]="(dropdownOptionsTimeRecordType$ | async) ?? []"
                          formControlName="timerecordtypeId"
                          label="TYP" />
          <work-ui-input-datepicker variant="dateRange"
                                    rangeStartDateFormControlName="start"
                                    rangeEndDateFormControlName="end"
                                    label="VON_BIS"
                                    rangeStartDatePlaceholder="VON"
                                    rangeEndDatePlaceholder="BIS" />
          <work-ui-select (valueChanged)="formGroupUpdate.patchValue({dayPart: $event})"
                          [options]="dayPartOptions"
                          formControlName="dayPart"
                          label="TAGES_ANTEIL" />
          @if (formGroupUpdate.value.timerecordtypeId && [6, 7].indexOf(formGroupUpdate.value.timerecordtypeId) > -1) {
            <work-ui-input-field formControlName="percentage"
                                 label="ARBEITSUNFAEHIGKEIT"
                                 type="number" />
          }
          <work-ui-input-field formControlName="comment"
                               label="KOMMENTAR"
                               type="text"
                               variant="textarea"
                               [rows]="1"
                               [setAutoHeight]="true" />
        </form>

      }
    }
  </ng-container>
  <ng-container modal-footer>
    @if (absenceToUpdate()) {
      <work-ui-button (buttonClick)="updateAbsence()"
                      [(loadingState)]="formSaveLoadingState"
                      [disabled]="formGroupUpdate.invalid || formGroupUpdate.untouched"
                      [showLoadingOnClick]="true"
                      [text]="'SPEICHERN' | translate" />
    } @else {
      <work-ui-button (buttonClick)="createAbsence()"
                      [(loadingState)]="formSaveLoadingState"
                      [disabled]="formGroupCreate.invalid || formGroupCreate.untouched"
                      [showLoadingOnClick]="true"
                      [text]="'ERSTELLEN' | translate" />
    }
    <work-ui-button (click)="absenceCreateUpdateModal.close();"
                    [text]="'SCHLIESSEN' | translate"
                    variant="secondary" />
  </ng-container>
</work-ui-modal>
